module.exports = __webpack_public_path__ + "img/photolight_thumbnail-600x450.25192bea.jpg";